import React, { FunctionComponent, memo, useCallback, useState } from 'react';

import { WorkProjectsTypes } from 'containers/WorkPage/WorkPage.types';
import { useGlobalStore } from 'store';
import useWindowSize from 'u9/hooks/useWindowSize';
import { initialLoadMotionProps } from 'utils/styles/animations';
import { breakpointDesktop } from 'utils/styles/vars';

import GridItem from './GridItem/GridItem';

import * as S from './GridView.styles';

export interface GridViewProps {
  projects: WorkProjectsTypes[];
}

const defaultProps: Partial<GridViewProps> = {
  projects: [],
};

const GridView: FunctionComponent<GridViewProps> = ({ projects, ...rest }) => {
  const [activeId, setActiveId] = useState<string>(null);

  const { width } = useWindowSize();
  const { headerText: headerTextStore, setHeaderText } = useGlobalStore();

  const isMobile = width < breakpointDesktop;

  const onHoverStart = useCallback(
    (headerText, headerColoredText, color) => {
      setHeaderText({
        ...headerTextStore,
        normal: headerText,
        colored: headerColoredText,
        color,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [headerTextStore]
  );

  const onHoverEnd = useCallback(() => {
    setHeaderText({
      ...headerTextStore,
      normal: '',
      colored: '',
      color: '',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerTextStore]);

  const list = projects.map(props => (
    <GridItem
      key={props.id}
      onHoverStart={onHoverStart}
      onHoverEnd={onHoverEnd}
      isMobile={isMobile}
      activeId={activeId}
      setActiveId={setActiveId}
      {...props}
    />
  ));

  return (
    <S.Wrapper role="list" {...initialLoadMotionProps} {...rest}>
      {list}
    </S.Wrapper>
  );
};

GridView.defaultProps = defaultProps;

export default memo(GridView);
